import React from "react";
import Modal from "components/Modal";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import { productUsageStore } from "features/ProductUsage/ProductUsageStore";
import Table from "components/Table";
import clsx from "clsx";
import useProductUsageColumns from "./useProductUsageColumns";
import useProductUsagePagination from "./useProductUsagePagination";
import ProductUsageSaveFooter from "./ProductUsageSaveFooter";

const ProductUsageList = () => {
  const { t } = useTranslation();

  const { id, modal } = productUsageStore;
  const view = modal.view;
  const isBuildings = view === "buildings";
  const columns = useProductUsageColumns(isBuildings);
  const { list, fetchData } = useProductUsagePagination(id, view);

  React.useEffect(() => {
    if (modal.open) fetchData(0);
  }, [modal.open, fetchData]);

  const closeModal = () => {
    productUsageStore.closeModal();
  };

  const saveProduct = () => {
    modal.onSave?.();
    closeModal();
  };

  return (
    <Modal
      isOpen={modal.open}
      setIsOpen={closeModal}
      title={
        isBuildings
          ? t("productEditor.productUsageBuildingsTitle")
          : t("productEditor.affectedComponents")
      }
      containerClassName="min-w-[1024px]"
      closeButton
      footerClassName="!px-0"
      footer={
        modal.footer && (
          <ProductUsageSaveFooter onCancel={closeModal} onSave={saveProduct} />
        )
      }
    >
      {(list.count > 0 || list.loading) && (
        <>
          <Table
            key={`${id}-${view}`}
            getColumns={() => columns}
            data={list.items}
            fetchData={fetchData}
            totalDBRowCount={list.count}
            dataFetchLoading={list.loading}
            skeletonLoading={list.loading && list.count === 0}
            headerContainerStyle="!bg-white"
            headerDivStyle="!py-1 h-[24px] !px-6 !text-sm font-semibold text-gray-900 border-r !border-gray-200"
            customColumnStyle={clsx(
              "border-r h-[24px] last-of-type:border-r-0 !border-gray-200 !py-1",
              "first-of-type:pl-4 last-of-type:pr-4 text-xs font-medium text-gray-900 !px-6"
            )}
            customRowStyle="h-[24px] !border-gray-200"
          />

          <div className="bg-gray-50 text-gray-500 text-xs font-medium px-6 py-2 border-t border-gray-300">
            {t("productEditor.productUsageLoaded", {
              count: list.items.length,
              total: list.count,
            })}
          </div>
        </>
      )}
    </Modal>
  );
};

export default observer(ProductUsageList);
